/** @format */

import { observable, action } from 'mobx';
import Service from './service';
import { goodsItem } from './domain';
import { JDNativeToast } from '@jdreact/jdreact-core-lib';
import { API_SUCCESS } from '../../utils/common';
interface IStore {
  myRecord: goodsItem[];
  myFollow: goodsItem[];
  myCart: goodsItem[];
  addGoods: goodsItem | null;
  cartLoading: boolean;
  showCartIcon: boolean;
  followLoading: boolean;
  showFollowIcon: boolean;
  showRecordIcon: boolean;
  isLoadingRecordMore: boolean;
  isLoadRecordAll: boolean;
  isLoadingMore: boolean;
  isLoadAll: boolean;
  addLock: boolean;
  recordPageNum: number;
  followPageNum: number;
  loadRecordData: (this: IStore, cateId: string) => void;
  loadCartData: (this: IStore, cateId: string) => void;
  loadFollowData: (this: IStore, cateId: string) => void;
  clearCache: (this: IStore) => void;
  cartChange: (this: IStore, cartData: { data: any }) => void;
  followChange: (this: IStore, followData: { data: any }) => void;
  recordChange: (this: IStore, recordData: { data: any }) => void;
  handleCheck: (this: IStore, item: goodsItem) => void;
  handleAddGoods: (this: IStore, cateId: string, cb: Function) => void;
  showEmptyCartData: (this: IStore) => void;
  showEmptyFollowData: (this: IStore) => void;
  resetLoadMore: (this: IStore) => void;
  showEmptyRecordData: (this: IStore) => void;
  resetLoadRecordMore: (this: IStore) => void;
  goBack: (this: IStore, cb: Function) => void;
  loadMoreFollowData: (this: IStore, cateId: string) => void;
  loadFollowChange: (this: IStore, data: any) => void;
  loadMoreRecordData: (this: IStore, cateId: string) => void;
  loadRecordChange: (this: IStore, data: any) => void;
}
const storeData: IStore = {
  //历史记录
  myRecord: [],
  //我的关注
  myFollow: [],
  //购物车
  myCart: [],
  addGoods: null,
  cartLoading: false,
  showCartIcon: false,
  followLoading: false,
  showFollowIcon: false,
  showRecordIcon: false,
  isLoadingRecordMore: false,
  isLoadRecordAll: false,
  addLock: false,
  isLoadingMore: false,
  isLoadAll: false,
  recordPageNum: 1,
  followPageNum: 1,
  // 添加商品
  handleAddGoods: action(function handleAddGoods(this: IStore, cateId: string, cb: Function) {
    if (this.addLock) {
      return;
    }
    this.addLock = true;
    this.goBack(cb);
    Service.addGoods({
      compareSku: this.addGoods ? this.addGoods.skuId : '',
      compareCid: cateId,
    }).then(
      (res) => {
        if (res && res.code == API_SUCCESS) {
          JDNativeToast.show('添加成功', JDNativeToast.SHORT, JDNativeToast.SUCCESS);
          setTimeout(() => {
            this.goBack(cb);
          }, 200);
        } else {
          JDNativeToast.show(res.msg);
        }
      },
      (e) => {
        this.showEmptyCartData();
        console.log('e', e);
      }
    );
  }),
  goBack: action(function (cb: Function) {
    this.addLock = false;
    cb && cb;
  }),
  //购物车数据
  loadCartData: action(function loadCartData(this: IStore, cateId: string) {
    this.cartLoading = true;
    Service.getCart({
      compareCid: cateId,
    }).then(
      (res) => {
        this.cartChange(res);
      },
      (e) => {
        this.showEmptyCartData();
        console.log('e', e);
      }
    );
  }),
  clearCache: action(function loadCartData(this: IStore) {
    this.addGoods = null;
    this.myCart = [];
    this.myFollow = [];
    this.showCartIcon = false;
    this.showFollowIcon = false;
    this.showRecordIcon = false;
    this.isLoadingRecordMore = false;
    this.isLoadRecordAll = false;
    this.followPageNum = 1;
    this.recordPageNum = 1;
    this.isLoadingMore = false;
    this.isLoadAll = false;
  }),
  cartChange: action(function cartChange(this: IStore, cartData: { data: any }) {
    this.cartLoading = false;
    const data = cartData.data;
    if (data && data.cartSkuInfos && data.cartSkuInfos.length != 0) {
      this.myCart = data.cartSkuInfos.map((item: goodsItem) => {
        item.key = item.skuId;
        if (this.addGoods && item.key === this.addGoods.key) {
          item.checked = true;
        } else {
          item.checked = false;
        }
        item.disabled = item.comparingFlag || item.soldOutFlag;
        return item;
      });
    } else {
      this.showCartIcon = true;
    }
  }),
  showEmptyCartData: action(function showEmptyCartData(this: IStore) {
    this.showCartIcon = true;
    this.cartLoading = false;
  }),
  showEmptyFollowData: action(function showEmptyFollowData(this: IStore) {
    this.showFollowIcon = true;
    this.followLoading = false;
    this.isLoadingMore = false;
  }),
  showEmptyRecordData: action(function showEmptyRecordData(this: IStore) {
    this.showRecordIcon = true;
    this.isLoadingRecordMore = false;
  }),
  resetLoadRecordMore: action(function resetLoadRecordMore(this: IStore) {
    this.isLoadRecordAll = false;
    this.isLoadingRecordMore = false;
  }),
  resetLoadMore: action(function resetLoadMore(this: IStore) {
    this.isLoadAll = false;
    this.isLoadingMore = false;
  }),
  //历史数据
  loadRecordData: action(function loadRecordData(this: IStore, cateId: string, page: number = 1) {
    Service.getRecord({
      compareCid: cateId,
      page: this.recordPageNum,
    }).then(
      (res) => {
        this.recordChange(res);
      },
      (e) => {
        this.showEmptyRecordData();
        console.log('e', e);
      }
    );
  }),
  loadMoreRecordData: action(function loadMoreRecordData(this: IStore, cateId: string) {
    if (this.isLoadingRecordMore || this.isLoadRecordAll) {
      return;
    }

    this.isLoadingRecordMore = true;
    this.recordPageNum = this.recordPageNum + 1;
    Service.getRecord({
      compareCid: cateId,
      page: this.recordPageNum,
    }).then(
      (res) => {
        if (res && res.code == API_SUCCESS) {
          const data = res.data;

          if (!data.recordSkuList) return;
          this.loadRecordChange(data);
        }
      },
      (e) => {
        this.resetLoadRecordMore();
        console.log('e', e);
      }
    );
  }),
  loadRecordChange: action(function loadRecordChange(this: IStore, data: any) {
    let loadMoreData = data.recordSkuList.map((item: goodsItem) => {
      item.key = item.skuId;
      if (this.addGoods && item.key === this.addGoods.key) {
        item.checked = true;
      } else {
        item.checked = false;
      }

      item.disabled = item.comparingFlag || item.soldOutFlag;
      return item;
    });

    this.myRecord = this.myRecord.concat(loadMoreData);
    if (data.recordSkuList.length < data.pageSize) {
      this.isLoadRecordAll = true;
    }
    //重置分页lock
    this.isLoadingRecordMore = false;
    this.recordPageNum = data.pageNum;
  }),
  recordChange: action(function recordChange(this: IStore, recordData: { data: any }) {
    const data = recordData.data;
    if (data && data.recordSkuList && data.recordSkuList.length != 0) {
      this.myRecord = data.recordSkuList.map((item: goodsItem) => {
        item.key = item.skuId;
        if (this.addGoods && item.key === this.addGoods.key) {
          item.checked = true;
        } else {
          item.checked = false;
        }

        item.disabled = item.comparingFlag || item.soldOutFlag;
        return item;
      });
      if (data.recordSkuList.length < data.pageSize) {
        this.isLoadRecordAll = true;
      }
    } else {
      this.showRecordIcon = true;
    }
  }),
  //我的关注数据
  loadFollowData: action(function loadFollowData(this: IStore, cateId: string, page: number = 1) {
    this.followLoading = true;
    Service.getFollow({
      compareCid: cateId,
      page: this.followPageNum,
    }).then(
      (res) => {
        this.followChange(res);
      },
      (e) => {
        this.showEmptyFollowData();
        console.log('e', e);
      }
    );
  }),
  loadMoreFollowData: action(function loadMoreFollowData(this: IStore, cateId: string) {
    if (this.isLoadingMore || this.isLoadAll) {
      return;
    }

    this.isLoadingMore = true;
    this.followPageNum = this.followPageNum + 1;
    Service.getFollow({
      compareCid: cateId,
      page: this.followPageNum,
    }).then(
      (res) => {
        if (res && res.code == API_SUCCESS) {
          const data = res.data;

          if (!data.followSkuInfos) return;
          this.loadFollowChange(data);
        }
      },
      (e) => {
        this.resetLoadMore();
        console.log('e', e);
      }
    );
  }),
  loadFollowChange: action(function loadFollowMoreChange(this: IStore, data: any) {
    let loadMoreData = data.followSkuInfos.map((item: goodsItem) => {
      item.key = item.skuId;
      if (this.addGoods && item.key === this.addGoods.key) {
        item.checked = true;
      } else {
        item.checked = false;
      }

      item.disabled = item.comparingFlag || item.soldOutFlag;
      return item;
    });

    this.myFollow = this.myFollow.concat(loadMoreData);
    if (data.followSkuInfos.length < data.pageSize) {
      this.isLoadAll = true;
    }
    //重置分页lock
    this.isLoadingMore = false;
    this.followPageNum = data.pageNum;
  }),
  followChange: action(function followChange(this: IStore, followData: { data: any }) {
    this.followLoading = false;
    const data = followData.data;
    if (data && data.followSkuInfos && data.followSkuInfos.length != 0) {
      this.myFollow = data.followSkuInfos.map((item: goodsItem) => {
        item.key = item.skuId;
        if (this.addGoods && item.key === this.addGoods.key) {
          item.checked = true;
        } else {
          item.checked = false;
        }

        item.disabled = item.comparingFlag || item.soldOutFlag;
        return item;
      });
      if (data.followSkuInfos.length < data.pageSize) {
        this.isLoadAll = true;
      }
    } else {
      this.showFollowIcon = true;
    }
  }),

  handleCheck: action(function handleCheck(this: IStore, item: goodsItem) {
    if (item.disabled) {
      return;
    }
    let tmpItem = Object.assign({}, item);
    tmpItem.checked = !item.checked;
    const myCart = this.myCart.slice();
    const myFollow = this.myFollow.slice();
    const myRecord = this.myRecord.slice();
    const cartLen = this.myCart.length;
    const RecorEnd = this.myRecord.length + cartLen;
    let tmp = myCart.concat(myRecord, myFollow);
    let tmpMap = mapCheckGoods(tmp, tmpItem);
    this.myCart = tmpMap.slice(0, cartLen);
    this.myRecord = tmpMap.slice(cartLen, RecorEnd);
    this.myFollow = tmpMap.slice(RecorEnd);
    // if (myCart.some((g) => g.skuId == tmpItem.skuId)) {
    //   let tmpShopCart = mapCheckGoods(tmp, tmpItem);
    //   this.myCart = tmpShopCart;
    // }
    // if (myFollow.some((g) => g.skuId == tmpItem.skuId)) {
    //   let tmpMyFollows = mapCheckGoods(tmp, tmpItem);
    //   this.myFollow = tmpMyFollows;
    // }
    if (item.checked) {
      this.addGoods = tmpItem;
    } else {
      this.addGoods = null;
    }
  }),
  //优惠券
};
const store = observable(storeData);
function mapCheckGoods(data: any[], target: goodsItem) {
  return data.map((item: goodsItem) => {
    if (item.key === target.key) {
      item.checked = target.checked;
    } else {
      item.checked = false;
    }
    return item;
  });
}
export default store;
